import type { StripePriceWithTax } from '@racemap/sdk/schema/billing';
import type { StripeProducts } from '@racemap/sdk/schema/billing/StripeProducts';
import { RacemapAPIClient } from '@racemap/utilities/api-client';
import { OneMinuteInMillis } from '@racemap/utilities/consts/time';
import useSWR from 'swr';

const apiClient = RacemapAPIClient.fromWindowLocation();
export type PriceList = Record<StripeProducts, StripePriceWithTax>;

export function usePriceList({ isReseller }: { isReseller?: boolean } = {}): {
  priceList: PriceList | undefined;
  isReseller: boolean | undefined;
  isLoading: boolean;
  error: Error;
} {
  // if isReseller is not defined, we fetch the price list for the current user
  let key = 'get_price_list';
  if (isReseller != null) {
    // if isReseller is defined, we fetch the price list for the given user
    key += isReseller ? '_reseller' : '_customer';
  }
  const { data, isLoading, error } = useSWR(
    key,
    async () => {
      return await apiClient.getPriceList({ isReseller });
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      refreshInterval: OneMinuteInMillis * 30,
      keepPreviousData: true,
    },
  );
  const priceList = data?.list;

  return {
    priceList,
    isReseller: data?.isReseller,
    isLoading,
    error,
  };
}
